import React, { useState } from "react";
import { connect } from "react-redux";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Button, Toastr } from "../../../../revvComponents";

import { EVENT_NAMES } from "../../../../constants/events";

import { amplitudeLogEvent } from "../../../../utils/amplitudeUtils";

// Actions
import { provideFeedback } from "../../../../actions/MetalensActions/metalensActions";

const DocumentReviewProvideFeedback = ({
  show,
  onClose,
  docID,
  componentID,
  sharingHash,
  provideFeedbackAction,
}) => {
  const [completelyWrong, setCompletelyWrong] = useState(false);
  const [partiallyWrong, setPartiallyWrong] = useState(false);
  const [clausesMissing, setClausesMissing] = useState(false);
  const [note, setNote] = useState("");

  const _submitFeedback = () => {
    const data = {
      completely_wrong: completelyWrong,
      partially_wrong: partiallyWrong,
      clauses_missing: clausesMissing,
      note: note.trim(),
    };
    provideFeedbackAction(docID, componentID, data, sharingHash)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Thank you for the feedback.",
          timeout: 3000,
        });
        onClose();
      })
      .catch(() => {
        Toastr.showToastr({
          type: "failure",
          message: "Couldnot provide feedback",
          timeout: 3000,
        });
      });
    // Amplitude
    amplitudeLogEvent(EVENT_NAMES.CLAUSE_ANALYSIS_FEEDBACK_SUBMITTED, {
      Selection: data,
    });
  };

  return (
    <Modal
      classNames={{
        modal: "documentreviewclauses-filter-modal",
      }}
      open={show}
      onClose={onClose}
      center>
      <div className="documentreviewclauses-feedback-inner-wrapper">
        <div
          data-belongsto="metalens-dropdown"
          className="documentreviewclauses-feedback-head">
          <div
            className="documentreviewclauses-feedback-head-title"
            data-belongsto="metalens-dropdown">
            Provide Feedback
          </div>
        </div>
        <div className="documentreviewclauses-filter-inner-wrapper">
          <div
            data-belongsto="metalens-dropdown"
            className="documentreviewclauses-feedback-body">
            <div className="documentreviewclauses-feedback-body-description">
              Didn’t find what you were looking for? Tell us where we went
              wrong.
            </div>
            <div className="documentreviewclauses-feedback-options">
              <div
                className="documentreviewclauses-filter-item"
                data-belongsto="metalens-dropdown">
                <span
                  data-belongsto="metalens-dropdown"
                  className="assetitem-checkbox-wrapper">
                  <label
                    data-belongsto="metalens-dropdown"
                    htmlFor="documentreviewclauses-provide-feedback-1"
                    id=""
                    className="documentreviewclauses-filter-item-container">
                    Completely incorrect suggestions information/suggestion
                    <input
                      data-belongsto="metalens-dropdown"
                      data-test="documentreviewclauses-provide-feedback-1"
                      onChange={() => {
                        setCompletelyWrong(!completelyWrong);
                      }}
                      id="documentreviewclauses-provide-feedback-1"
                      type="checkbox"
                      checked={completelyWrong}
                    />
                    <span
                      onClick={() => {
                        setCompletelyWrong(!completelyWrong);
                      }}
                      tabIndex="0"
                      role="button"
                      onKeyDown={() => {}}
                      data-belongsto="metalens-dropdown"
                      className="documentreviewclauses-filter-item-checkmark"
                    />
                  </label>
                </span>
              </div>
              <div
                className="documentreviewclauses-filter-item"
                data-belongsto="metalens-dropdown">
                <span
                  data-belongsto="metalens-dropdown"
                  className="assetitem-checkbox-wrapper">
                  <label
                    data-belongsto="metalens-dropdown"
                    htmlFor="documentreviewclauses-provide-feedback-2"
                    id=""
                    className="documentreviewclauses-filter-item-container">
                    Partially incorrect suggestions information/suggestion
                    <input
                      data-belongsto="metalens-dropdown"
                      data-test="documentreviewclauses-provide-feedback-2"
                      onChange={() => {
                        setPartiallyWrong(!partiallyWrong);
                      }}
                      id="documentreviewclauses-provide-feedback-2"
                      type="checkbox"
                      checked={partiallyWrong}
                    />
                    <span
                      onClick={() => {
                        setPartiallyWrong(!partiallyWrong);
                      }}
                      tabIndex="0"
                      role="button"
                      onKeyDown={() => {}}
                      data-belongsto="metalens-dropdown"
                      className="documentreviewclauses-filter-item-checkmark"
                    />
                  </label>
                </span>
              </div>
              <div
                className="documentreviewclauses-filter-item"
                data-belongsto="metalens-dropdown">
                <span
                  data-belongsto="metalens-dropdown"
                  className="assetitem-checkbox-wrapper">
                  <label
                    data-belongsto="metalens-dropdown"
                    htmlFor="documentreviewclauses-provide-feedback-3"
                    id=""
                    className="documentreviewclauses-filter-item-container">
                    Some clauses are missing
                    <input
                      data-belongsto="metalens-dropdown"
                      data-test="documentreviewclauses-provide-feedback-3"
                      onChange={() => {
                        setClausesMissing(!clausesMissing);
                      }}
                      id="all-filter-id"
                      type="checkbox"
                      checked={clausesMissing}
                    />
                    <span
                      onClick={() => {
                        setClausesMissing(!clausesMissing);
                      }}
                      tabIndex="0"
                      role="button"
                      onKeyDown={() => {}}
                      data-belongsto="metalens-dropdown"
                      className="documentreviewclauses-filter-item-checkmark"
                    />
                  </label>
                </span>
              </div>
            </div>
          </div>
          <div className="documentreviewclauses-feedback-note">
            <p className="documentreviewclauses-feedback-note-title">Note</p>
            <textarea
              data-test="documentreviewclauses-feedback-note-text"
              rows="5"
              value={note}
              data-belongsto="metalens-dropdown"
              onChange={e => setNote(e.target.value)}
              placeholder="Tell us your Inputs on what we could do better"
            />
          </div>
        </div>
      </div>
      <div
        data-belongsto="metalens-dropdown"
        className="documentreviewclauses-feedback-foot">
        <Button
          type="four"
          data-test="documentreviewclauses-filter-apply-btn"
          data-belongsto="metalens-dropdown"
          className="documentreviewclauses-filter-apply-btn"
          onClick={event => {
            _submitFeedback();
            onClose(event);
          }}
          id="documentreviewclauses-filter-apply-btn-1">
          &nbsp; Submit feedback
        </Button>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = {
  provideFeedbackAction: provideFeedback,
};

export default connect(null, mapDispatchToProps)(DocumentReviewProvideFeedback);
